import {cssRule} from 'typestyle';
import {rem} from 'csx';

cssRule('.table thead th', {
    verticalAlign: 'bottom',
    borderBottom: 'none',
});

cssRule('.table td, .table th', {
    padding: rem(0.75),
    verticalAlign: 'top',
    borderTop: 'none',
});



// WEBPACK FOOTER //
// ./src/styles/bootstrap-overwrite.ts